import { type FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { getStatWinner } from 'app/utils/entities/match_data';
import StatValue from 'app/components/StatValue';

import style from './style.module.scss';

interface Props {
  statLine: StatLine<StatPlayer | PlayerBase>;
}

const PlayersHeadToHeadLine: FC<Props> = ({ statLine }) => {
  const { t } = useTranslation();

  const [isTeam1StatWinner, isTeam2StatWinner] = getStatWinner(statLine);

  return (
    <li className={style.headToHeadLine}>
      <span
        className={classNames(style.playerStatTeam1Value, {
          [style.playerStatValueWinner]: isTeam1StatWinner
        })}
      >
        <span>
          <StatValue value={statLine.team1Value} displayFunction={statLine.displayFunction} />
        </span>
        <span className={style.borderEffect} />
      </span>
      <div className={style.statName}>{t(`block-players_stats-${statLine.name}`)}</div>
      <span
        className={classNames(style.playerStatTeam2Value, {
          [style.playerStatValueWinner]: isTeam2StatWinner
        })}
      >
        <span className={style.borderEffect} />
        <span>
          <StatValue value={statLine.team2Value} displayFunction={statLine.displayFunction} />
        </span>
      </span>
    </li>
  );
};

PlayersHeadToHeadLine.displayName = 'PlayersHeadToHeadLine';

export default PlayersHeadToHeadLine;
